// extracted by mini-css-extract-plugin
module.exports = {"occupanciesContainer":"rate_plan_occupancy_occupanciesContainer__2QEMq","occupancyCell":"rate_plan_occupancy_occupancyCell__-f20F"};